function tips() {
  const shape = document.querySelector('.tips__shape');
  const wrapper = document.querySelector('.tips');
  const grids = document.querySelectorAll('.tips__item');

  function isWrapperPartiallyInView() {
    const rect = wrapper.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  window.addEventListener('scroll', () => {
    if (isWrapperPartiallyInView()) {
      const wrapperTopRelativeToViewport = wrapper.getBoundingClientRect().top;
      const viewportHeight = window.innerHeight;
      const scrollDistance = Math.max(
        0,
        -wrapperTopRelativeToViewport + viewportHeight / 3
      );
      const twoThirdsOfViewport = (viewportHeight * 2) / 3;
      let shapePosition = scrollDistance;

      // Check if the wrapper's top is above two-thirds of the viewport
      if (
        wrapperTopRelativeToViewport < twoThirdsOfViewport &&
        wrapperTopRelativeToViewport >
          -wrapper.offsetHeight + (viewportHeight - twoThirdsOfViewport)
      ) {
        shape.style.transform = `translateY(${shapePosition}px)`;
      }

      grids.forEach((grid) => {
        const gridRect = grid.getBoundingClientRect();
        const shapeRect = shape.getBoundingClientRect();

        if (
          shapeRect.top < gridRect.bottom &&
          shapeRect.bottom > gridRect.top
        ) {
          grid.classList.add('is-active');
        } else {
          grid.classList.remove('is-active');
        }
      });
    }
  });
}
